export const transition = `
  transition: 150ms linear;
`;
